<template>
	<div class="container pb_0">
		<div class="sub_top">
			<div class="top_content">
				<div class="headline">
					<p class="sub_title">
						{{ $t('rtr_personal-request-receive.title1') }}
					</p>
					<p class="sub_text">
						{{ $t('rtr_personal-request-receive.text1') }}<br />
						{{ $t('rtr_personal-request-receive.text2') }}
					</p>

					<div class="button_area">
						<button class="button_bg_red mr_10" @click="toLogin">
							{{ $t('button.cryptocurrency_request') }}
						</button>
						<button class="button_bg_black" @click="notYet">
							{{ $t('button.down') }}
						</button>
					</div>
				</div>
			</div>
		</div>

		<section>
			<div class="sub_content1 sub_content_back">
				<div class="sub_content">
					<div class="detail_area_center">
						<div>
							<h2 class="title">
								{{ $t('rtr_personal-request-receive.title2') }}
							</h2>
							<p class="text">
								{{ $t('rtr_personal-request-receive.text3') }}<br />
								{{ $t('rtr_personal-request-receive.text4') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="img_area">
						<img src="@/assets/images/sub/receive_03.png" alt="" />
					</div>
					<div class="detail_area">
						<div class="detail tac">
							<h2 class="title">
								{{ $t('rtr_personal-request-receive.title3') }}<br />
								{{ $t('rtr_personal-request-receive.title4') }}
							</h2>
							<p class="text">
								{{ $t('rtr_personal-request-receive.text5') }}<br />
								{{ $t('rtr_personal-request-receive.text6') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="detail_area">
						<div class="detail type_02 tac">
							<h2 class="title">
								{{ $t('rtr_personal-request-receive.title5') }}
							</h2>
							<p class="text">
								{{ $t('rtr_personal-request-receive.text7') }}<br />
								{{ $t('rtr_personal-request-receive.text8') }}
							</p>
						</div>
					</div>
					<div class="img_area">
						<img src="@/assets/images/sub/receive_04.png" alt="" />
					</div>
				</div>
			</div>
		</section>
		<section>
			<div class="sub_bottom sub_bottom_back">
				<p class="fc_white fw_bold">
					{{ $t('rtr_personal-request-receive.text9') }}
				</p>
				<br />
				<p class="fc_white fw_bold">
					{{ $t('rtr_personal-request-receive.text10') }}
				</p>
			</div>
		</section>
		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="img_area">
						<img src="@/assets/images/sub/receive_05.png" alt="" />
					</div>
					<div class="detail_area">
						<div class="detail tac">
							<h2 class="title">
								{{ $t('rtr_personal-request-receive.title6') }}<br />
								{{ $t('rtr_personal-request-receive.title7') }}
							</h2>
							<p class="text mb_50">
								{{ $t('rtr_personal-request-receive.text11') }}<br />
								{{ $t('rtr_personal-request-receive.text12') }}
							</p>
							<router-link to class="link_type_02" @click="notYet">
								{{ $t('rtr_personal-request-receive.text13') }}
								<span class="CIRCLE_ARROW"></span>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'Receive',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>

<style scoped></style>
